// core
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

// services
import { OpenTileLayoutService } from '../open-tile-layout/open-tile-layout.service';

@Component({
  selector: 'open-tile-checkbox',
  templateUrl: './open-tile-checkbox.component.html',
  styleUrls: ['./open-tile-checkbox.component.scss']
})
export class OpenTileCheckboxComponent implements OnInit {
  @Input() form: any;
  @Input() question: any;
  @ViewChild('container') container!: ElementRef<HTMLInputElement>;

  questionControl: any;
  columns!: number;

  constructor(private openTileLayoutService: OpenTileLayoutService) { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setLayout();
      window.addEventListener('resize', this.setLayout);
    }, 0)
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.setLayout);
  }

  get fieldValue() {
    return this.questionControl.value;
  }

  setLayout = () => {
    this.columns = this.openTileLayoutService.getColumns(
      this.container,
      this.container.nativeElement.querySelector('.checkbox-wrapper'),
      this.question.settings
    ) || 0;
  }

  public playAnimation(option: any) {
    if (!this.question.settings) {
      this.question.settings = {};
    }

    if (!this.question.settings.size) {
      this.question.settings.size = "";
    }

    if (
      this.question.settings.icon_type &&
      this.question.settings.icon_type === 'animation'
    ) {
      this.question.settings.choices.forEach((choice: any) => {
        let player: any = document.querySelector('lottie-player.' + choice.value);

        if (player) {
          if (this.question.type === 'choice') {
            choice.value === option.value ? player.play() : player.stop();
          }
          if (this.question.type === 'multiple_choice') {
            this.questionControl.value[choice.value] === true ? player.play() : player.stop();
          }
        }
      });
    }
  }
}

